import {
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap'
import { NextPage } from 'next'
import React, { useState, useEffect, useRef } from 'react'
import { withI18n } from '~/hocs'
import { AppCommonProps } from 'types/app'
import moment from 'moment'
import dynamic from 'next/dynamic'
const Picker = dynamic(() => import('emoji-picker-react'), { ssr: false })
import _ from 'lodash'
import Link from 'next/link'
import { routes } from '~/router'

const ReplyInformation: NextPage<AppCommonProps> = ({
    reply, profile, setIsEdit, isEdit, setHeight, videoUserID, replyItemRef, handleHideReply, handleDeleteReply
}: any) => {
    return (
        <div className="d-flex">
            {reply.sso_uid ? <><span>{reply.nick_name
                ? <>{reply.nick_name}</>
                : (reply?.userSSO.nick_name ? <>{reply?.userSSO.nick_name}</>
                    : <>{reply?.email.substring(0, 1) + '**********' + reply?.email.substring(reply?.email.length - 1, reply?.email.length)}</>)}さん</span></> : <>
                <Link href={{
                    pathname: routes.user.username.href,
                    query: { id: reply.user_id }
                }}>
                    <a target="_blank" className="ac-text-blue d-block">
                        <span>{reply.nick_name
                            ? <>{reply.nick_name}</>
                            : <>{reply?.email.substring(0, 1) + '**********' + reply?.email.substring(reply?.email.length - 1, reply?.email.length)}</>}さん</span>
                    </a>
                </Link>
            </>}
            <span className="ml-3">{moment(reply.created_at).format("LL")}</span>
            <div className="ml-3 comment-options">
                {reply.user_id === profile.id && <OverlayTrigger
                    key={'top'}
                    placement={'top'}
                    overlay={
                        <Tooltip id={`tooltip-top`}>
                            編集
                        </Tooltip>
                    }
                >
                    <span className="text-949494">
                        <i className="fa fa-pencil" aria-hidden="true" onClick={() => {
                            setIsEdit(!isEdit)
                            setHeight(`${replyItemRef.current?.clientHeight + 19}px`)
                        }}></i>
                    </span>
                </OverlayTrigger>}
                {(videoUserID === profile.id) && <OverlayTrigger
                    key={'top'}
                    placement={'top'}
                    overlay={
                        <Tooltip id={`tooltip-top`}>
                            非表示
                        </Tooltip>
                    }
                >
                    <span className="text-949494">
                        <i className="fa fa-eye-slash ml-2" aria-hidden="true" onClick={handleHideReply}></i>
                    </span>
                </OverlayTrigger>}
                {(reply.user_id === profile.id || videoUserID === profile.id) && <span className="ac-text-danger">
                    <OverlayTrigger
                        key={'top'}
                        placement={'top'}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                                消去
                            </Tooltip>
                        }
                    >
                        <i className="fa fa-trash ml-2" aria-hidden="true" onClick={handleDeleteReply}></i>
                    </OverlayTrigger>
                </span>}
            </div>
        </div>
    )
}


export default withI18n(ReplyInformation)
